<div class="signature">
        <a class="mtv-primary-color" (click)="ClearSign()" *ngIf="value">Clear</a>
        <a class="mtv-primary-color" (click)="StartSign()" *ngIf="!value">Sign</a>
        <canvas #canvas></canvas>
    </div>


// WEBPACK FOOTER //
// /app/src/app/components/signature-field/signature-field.component.ts.SignatureFieldComponent.html